import {
  Box,
  Typography,
  Link,
  CircularProgress
} from '@mui/material';
import { useTranslation } from 'react-i18next';

interface AcknowledgmentStepProps {
  isLoading?: boolean;
  showcaseCount: number;
}

const AcknowledgmentStep: React.FC<AcknowledgmentStepProps> = ({
  isLoading,
}) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="h6" gutterBottom>
        {t('quickListingWizard.acknowledgmentTitle')}
      </Typography>

      {isLoading && (
        <Box sx={{ display: 'flex', justifyContent: 'center', my: 3 }}>
          <CircularProgress />
        </Box>
      )}

      <Typography variant="body1" gutterBottom sx={{ mb: 2 }}>
        {t('quickListingWizard.acknowledgmentText')}
      </Typography>

      <Typography variant="body1" gutterBottom>
        {t('quickListingWizard.nextSteps')}
      </Typography>

      <Box sx={{ mt: 2 }}>
        <Typography variant="body1" gutterBottom>
          1. <Link
            href="/showcase-management"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('quickListingWizard.addMoreShowcases')}
          </Link>
        </Typography>

        <Typography variant="body1" gutterBottom>
          2. <Link
              href="/stylist"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('quickListingWizard.enhanceStylistProfile')}
            </Link>
        </Typography>

        <Typography variant="body1" gutterBottom>
          3. <Link
              href="/plans"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('quickListingWizard.addMorePlans')}
            </Link>
        </Typography>
      </Box>
    </Box>
  );
};

export default AcknowledgmentStep;
